import { Root } from 'hast';
import { ElementType } from 'react';
import rehypeParse from 'rehype-parse';
import { Data, PluggableList, unified } from 'unified';
import wpAutop from 'wpautop';

import rehypeText from './rehype/rehype-text';
import wpShortcodeUnautop from './wpShortcodeUnautop';
import wpTransformShortcodes from './wpTransformShortcodes';
import IntlTextTruncator, {
  TruncateTextOptions,
} from '@/lib/utils/IntlTextTruncator';

type Processor = import('unified').Processor<
  Root,
  undefined,
  undefined,
  undefined,
  undefined
>;

export default function wpContentToText({
  // rehypeParse: parse,
  transformers = [],
  plugins = [],
  filters = [
    wpAutop as (html: string) => string,
    wpShortcodeUnautop,
    wpTransformShortcodes,
    // (html) => console.log(html) || html,
  ],
  locale,
  truncate: truncateOptions,
}: {
  components?: { [key: string]: ElementType };
  transformers?: Array<(tree: Root) => Root>;
  plugins?: PluggableList;
  filters?: Array<(html: string) => string>;
  locale?: string;
  truncate?: TruncateTextOptions;
}): (html: string, data?: object) => string {
  const processor: Processor = unified().use(rehypeParse, { fragment: true });
  transformers.forEach((transformer) => {
    processor.use(() => transformer);
  });
  processor.use(plugins);
  processor.use(rehypeText);

  const truncate = truncateOptions
    ? (string: string) =>
        new IntlTextTruncator(locale, truncateOptions).format(string)
    : (v: string) => v;

  return (html: string, data: Data = {}) =>
    truncate(
      processor
        .data(data)
        .processSync(filters.reduce((s, fn) => fn(s), html))
        .value.toString(),
    );
}
